<template>
  <Spinner v-if="creditCardStore.isLoading"></Spinner>
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--mypage">

      <Header />

      <section class="l-content-area">
        <div class="l-content">

          <!-- MYPAGE -->
          <section class="p-bloc p-bloc--mypage">
            <div class="p-bloc__content l-wrap__outer">
              <div class="l-wrap__inner">

                <section class="p-mypage">

                  <!-- Mypage Menu -->
                  <NavbarMyPage />

                  <!-- Side Menu -->
                  <SideMenu />

                  <!-- Mypage Content -->
                  <div class="p-mypage__content">
                    <div class="mypage-content">

                      <!-- payment -->
                      <div class="p-mypage__payment p-mypage__payment--list mypage-bloc">
                        <div class="mypage-bloc__head">
                          <h2>{{ $t('LABEL_PAYMENT_SETTINGS') }}</h2>
                          <div class="mypage-bloc__btn">
                            <button class="bloc__act-btn bloc__act-btn--add-payment" @click="actionRegister()"><span>{{ $t('LABEL_CARD_REGISTER') }}</span><img src="@/assets/img/ui_parts/svg/bloc_btn_add.svg" :alt="$t('LABEL_CARD_REGISTER')" /></button>
                          </div>
                        </div>
                        <div class="mypage-bloc__content">

                          <!-- payment grid -->
                          <div class="payment__grid">
                            <div class="c-payment-card" :class="{ 'is-active': JSON.parse(creditCard.default_flag), 'is-lock': JSON.parse(creditCard.use_subscription_flag) }" v-for="creditCard in creditCardStore.creditCards" :key="creditCard.creditcard_info_id">
                              <div class="c-flip-card">
                                <!-- front -->
                                <div class="c-flip-card__face c-payment-card__front">
                                  <div class="c-payment-card__brand">
                                    <div class="logo">
                                      <img v-if="creditCard.card_brand_id === CARD_BRAND_VISA" src="@/assets/img/ui_parts/creditcard_logo_visa.png" :alt="creditCard.card_brand">
                                      <img v-if="creditCard.card_brand_id === CARD_BRAND_JCB" src="@/assets/img/ui_parts/creditcard_logo_jcb.png" :alt="creditCard.card_brand">
                                      <img v-if="creditCard.card_brand_id === CARD_BRAND_MASTER" src="@/assets/img/ui_parts/creditcard_logo_master.png" :alt="creditCard.card_brand">
                                      <img v-if="creditCard.card_brand_id === CARD_BRAND_AMERICAN_EXPRESS" src="@/assets/img/ui_parts/creditcard_logo_amex.png" :alt="creditCard.card_brand">
                                    </div>
                                    <dl>
                                      <dt class="name">{{ creditCard.card_brand }}</dt>
                                      <!-- Card number 1 displays the information from card number 2 to meet the UI requirements. -->
                                      <dd class="number">{{ creditCard.creditcard_number2 }}{{ creditCard.creditcard_number2 }}{{ creditCard.creditcard_number3 }}{{ creditCard.creditcard_number4.slice(0, 2) }}&nbsp;{{ creditCard.creditcard_number4.slice(2, 4) }}</dd>
                                    </dl>
                                  </div>
                                  <div class="c-payment-card__info">
                                    <dl>
                                      <dt>{{ $t('LABEL_CARD_HOLDER_NAME') }}</dt>
                                      <dd>
                                        <p class="cardholder">{{ creditCard.holder_name }}</p>
                                      </dd>
                                    </dl>
                                    <dl>
                                      <dt>{{ $t('LABEL_EXPIRATION_YEAR') }}</dt>
                                      <dd>
                                        <p class="expiration" :class="{ 'is-expired': isExpiredCard(creditCard) }">{{ formatCardExpirationDate(creditCard) }}<span>{{ isExpiredCard(creditCard) ? $t('LABEL_EXPIRED') : ''  }}</span></p>
                                      </dd>
                                    </dl>
                                    <dl>
                                      <dt>{{ $t('LABEL_RECURRING_BILLING') }}</dt>
                                      <dd>
                                        <p class="subscription" :class="{ 'is-active': JSON.parse(creditCard.use_subscription_flag) }">{{ JSON.parse(creditCard.use_subscription_flag) ? $t('LABEL_SUBSCRIPTION_ACTIVE') : $t('LABEL_SUBSCRIPTION_NOT_SET') }}</p>
                                      </dd>
                                    </dl>
                                  </div>
                                </div>
                                <!-- back -->
                                <div class="c-flip-card__face c-payment-card__back">
                                  <div class="c-payment-card__setting">
                                    <ul class="c-payment__action">
                                      <li><button class="payment__act-btn payment__act-btn--edit" @click="actionEdit(creditCard)">{{ $t('LABEL_BUTTON_EDIT') }}</button></li>
                                      <li v-if="!isExpiredCard(creditCard)" ><button class="payment__act-btn payment__act-btn--select">{{ $t('LABEL_SET_PAYMENT_CARD') }}</button></li>
                                      <li v-else><p class="payment__act-txt payment__act-txt--select">{{ $t('LABEL_PAYMENT_CANNOT_USE_TEXT_1') }}<br>{{ $t('LABEL_PAYMENT_CANNOT_USE_TEXT_2') }}</p></li>
                                      <li v-if="!JSON.parse(creditCard.use_subscription_flag)"><button class="payment__act-btn payment__act-btn--delete">{{ $t('LABEL_CREDIT_CARD_DELETE') }}</button></li>
                                      <li v-else><p class="payment__act-txt payment__act-txt--delete">{{ $t('LABEL_SUBSCRIPTION_IN_USE_TEXT_1') }}<br>{{$t('LABEL_SUBSCRIPTION_IN_USE_TEXT_2') }}</p></li>
                                      <li><button class="payment__act-btn payment__act-btn--back">{{ $t('LABEL_RETURN_BUTTON') }}</button></li>
                                    </ul>
                                    <div class="c-payment__confirm">
                                      <p>{{ $t('LABEL_REMOVE_CARD_CONFIRM_TEXT') }}</p>
                                      <ul>
                                        <li><button class="payment__conf-btn payment__conf-btn--cancel">{{ $t('LABEL_CANCEL') }}</button></li>
                                        <li><button class="payment__conf-btn payment__conf-btn--delete" @click="creditCardStore.deleteCreditCard(creditCard.creditcard_info_id)">{{ $t('LABEL_BUTTON_DELETE') }}</button></li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- + -->
                            <div class="c-payment-add">
                              <button class="card__add-btn card__add-btn--payment" @click="actionRegister()"><span class="icon"><img src="@/assets/img/ui_parts/svg/card_btn_add.svg" alt="＋" /></span>{{ $t('LABEL_ADD_CARD') }}</button>
                            </div>

                          </div><!-- .payment__grid -->

                        </div>
                      </div>

                      <CreditCardRegisterForm />

                    </div><!-- .mypage-content -->
                  </div>

                </section>

              </div>
            </div>
          </section>

        </div><!-- .l-content -->
      </section><!-- .l-content-area -->

    </div><!-- .l-project-wrap -->

    <Footer />
  </div>

</template>

<script setup>

import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import SideMenu from "@/components/SideMenu.vue";
import {onMounted, onUpdated} from "vue";
import {useCreditCardStore} from "@/stores/creditCardStore"
import {CARD_BRAND_AMERICAN_EXPRESS, CARD_BRAND_JCB, CARD_BRAND_MASTER, CARD_BRAND_VISA} from "@/data/constants";
import Spinner from "@/components/Spinner.vue";
import CreditCardRegisterForm from "@/components/CreditCardRegisterForm.vue";
import {initializeMain} from "@/assets/js/entries/main";

const creditCardStore = useCreditCardStore();

function formatCardExpirationDate(creditCard) {
    return creditCard.month.padStart(2, '0') +'/'+ creditCard.year.slice(2);
}

function formatCardNumberGroups(str) {
    return str.replace(/(.{4})/g, '$1 ').trim();
}

function actionEdit(creditCard) {
    creditCardStore.isCreditCardEdit = true;
    creditCardStore.creditCardForm.card_number = formatCardNumberGroups(creditCard.creditcard_number1 + creditCard.creditcard_number2 + creditCard.creditcard_number3 + creditCard.creditcard_number4);
    creditCardStore.creditCardForm.credit_card_id = creditCard.creditcard_info_id;
    creditCardStore.creditCardForm.expiration_date = creditCard.month.padStart(2, '0') + '/' + creditCard.year.slice(2);
    creditCardStore.creditCardForm.holder_name = creditCard.holder_name;
    creditCardStore.creditCardForm.card_brand_code = creditCard.card_brand_id;

    setTimeout(() => {
        if(document){
            const cardEls = document.querySelectorAll('.c-payment-card');
            cardEls.forEach(cardEl => {
                cardEl.classList.remove('is-flip');
            }); 
        }
    }, 0);
}

function actionRegister() {
    creditCardStore.isCreditCardEdit = false;
}

function isExpiredCard(creditCard) {
    let d = new Date();
    let year = d.getFullYear();

    if (creditCard.year < year) {
        return true;
    }

    return parseInt(creditCard.year) === year && creditCard.month < d.getMonth();
}

onMounted(async () => {
    await creditCardStore.getCreditCards();

    if(!creditCardStore.paygentTokenModule.merchant_id || !creditCardStore.paygentTokenModule.token_generation_key) {
        await creditCardStore.getPaygentTokenModule();
    }
    
    $('html, body').animate({ scrollTop: 0 }, 300);
});

onUpdated(() => {
    initializeMain();
})

</script>